const FeatureHeroUX = () => {
    if ($('.section-feature-hero').length <= 0) return null;

    $('.section-feature-hero').each(function() {
        const $parent = $(this);
        const $tooltipToggles = $parent.find('.tooltip-toggle');
        
        const $tooltipContainer = $parent.find('.feature-hero-tooltips');
        const $tooltipCloseDesk = $parent.find('.close-tooltip-popup.desk');
        const $tooltipCloseMob = $parent.find('.close-tooltip-popup.mob');
        
        const $tooltipPopupDesk = $parent.find('.media-container .tooltip-content');
        const $tooltipPopupMob = $parent.find('.mobile-tooltip-popups .tooltip-content');
    
    
        $tooltipToggles.click(function() {
            //desktop
            if ($(window).width() >= 1200) {
                $('.tooltip-group.active').find('.tooltip-content').stop().fadeOut(300);
                $('.tooltip-group.active').removeClass('active');
    
                $(this).closest('.tooltip-group').toggleClass('active')
                let $popup =  $tooltipPopupDesk.filter(`[data-popup-id="${$(this).data('trigger-id')}"]`)
                $popup.stop().fadeToggle(300); 
            } else {
                $parent.find('.mobile-tooltip-popups .tooltip-content.active').removeClass('active');
    
                let $popup = $tooltipPopupMob.filter(`[data-popup-id="${$(this).data('trigger-id')}"]`);
                $popup.addClass('active');
                $parent.find('.mobile-tooltip-popups').fadeIn(300);
            }
        })
    
        //close desktop
        $tooltipCloseDesk.click(function() {
            $(this).closest('.tooltip-content').stop().fadeOut(300);
            $(this).closest('.tooltip-group').removeClass('active');
        })
    
        //close mobile
        $tooltipCloseMob.click(function() {
            $(this).closest('.mobile-tooltip-popups').fadeOut(300);
        })

        //video hero
        $parent.find('.hero-video').each(function() {
            let heroVid = $(this)[0];
            heroVid.addEventListener('ended', function() {
                $tooltipContainer.removeClass('hide-video-start');
            });
        })

        if ($parent.find('.subject-video video').length > 0) {
            const heroSubject = $parent.find('.subject-video video')[0];
            heroSubject.addEventListener('ended', function() {
                $tooltipContainer.removeClass('hide-video-start');
            });
        }
    })
}

export default FeatureHeroUX;